import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { Visualization_UnifiedBranch_$reflection, Visualization_Centerline_$reflection } from "../../RAWMap.Models/Common.js";
import { lambda_type, obj_type, option_type, array_type, record_type, class_type, int32_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { Bindings_CenterlinePointMeasurement_$reflection, Bindings_PlaneIdentifier_$reflection } from "../../RAWMap.Models/View/CenterlineMeasurement.js";

export class CenterlinePlane extends Record {
    constructor(centerlineType, branchSelection, index, callbackIdentifier, planeIdentifier) {
        super();
        this.centerlineType = centerlineType;
        this.branchSelection = branchSelection;
        this.index = (index | 0);
        this.callbackIdentifier = callbackIdentifier;
        this.planeIdentifier = planeIdentifier;
    }
}

export function CenterlinePlane_$reflection() {
    return record_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.CenterlinePlane", [], CenterlinePlane, () => [["centerlineType", Visualization_Centerline_$reflection()], ["branchSelection", Visualization_UnifiedBranch_$reflection()], ["index", int32_type], ["callbackIdentifier", class_type("System.Guid")], ["planeIdentifier", Bindings_PlaneIdentifier_$reflection()]]);
}

export class CenterlinePlaneRange extends Record {
    constructor(planeA, planeB) {
        super();
        this.planeA = planeA;
        this.planeB = planeB;
    }
}

export function CenterlinePlaneRange_$reflection() {
    return record_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.CenterlinePlaneRange", [], CenterlinePlaneRange, () => [["planeA", CenterlinePlane_$reflection()], ["planeB", CenterlinePlane_$reflection()]]);
}

export class CenterlinePlaneSource extends Record {
    constructor(rootFilter, planeIndexFilter) {
        super();
        this.rootFilter = rootFilter;
        this.planeIndexFilter = planeIndexFilter;
    }
}

export function CenterlinePlaneSource_$reflection() {
    return record_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.CenterlinePlaneSource", [], CenterlinePlaneSource, () => [["rootFilter", class_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.IFilter")], ["planeIndexFilter", class_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.IPlaneIndexFilter")]]);
}

export class PlanePipeline extends Record {
    constructor(centerlinePlane, centerlinePlaneSource) {
        super();
        this.centerlinePlane = centerlinePlane;
        this.centerlinePlaneSource = centerlinePlaneSource;
    }
}

export function PlanePipeline_$reflection() {
    return record_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.PlanePipeline", [], PlanePipeline, () => [["centerlinePlane", CenterlinePlane_$reflection()], ["centerlinePlaneSource", CenterlinePlaneSource_$reflection()]]);
}

export class RangeResult extends Record {
    constructor(pipelines, rangeValues) {
        super();
        this.pipelines = pipelines;
        this.rangeValues = rangeValues;
    }
}

export function RangeResult_$reflection() {
    return record_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.RangeResult", [], RangeResult, () => [["pipelines", array_type(PlanePipeline_$reflection())], ["rangeValues", array_type(Bindings_CenterlinePointMeasurement_$reflection())]]);
}

export class CenterlineMeasurementProps extends Record {
    constructor(planePipelines, selectedPlaneIdentifier) {
        super();
        this.planePipelines = planePipelines;
        this.selectedPlaneIdentifier = selectedPlaneIdentifier;
    }
}

export function CenterlineMeasurementProps_$reflection() {
    return record_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.CenterlineMeasurementProps", [], CenterlineMeasurementProps, () => [["planePipelines", array_type(PlanePipeline_$reflection())], ["selectedPlaneIdentifier", option_type(Bindings_PlaneIdentifier_$reflection())]]);
}

export class ICenterlineBranchSelection extends Record {
    constructor(ofBranchSelection) {
        super();
        this.ofBranchSelection = ofBranchSelection;
    }
}

export function ICenterlineBranchSelection_$reflection() {
    return record_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.ICenterlineBranchSelection", [], ICenterlineBranchSelection, () => [["ofBranchSelection", lambda_type(Visualization_UnifiedBranch_$reflection(), obj_type)]]);
}

